export const SET_KNOWLEDGE_BASE = "SET_KNOWLEDGE_BASE";
export const UPDATE_KNOWLEDGE_BASE = "UPDATE_KNOWLEDGE_BASE";
export const UPDATE_KNOWLEDGE_BASE_ITEMS = "UPDATE_KNOWLEDGE_BASE_ITEMS";
export const UPDATE_OPEN_KNOWLEDGE_BASE_ITEMS = "UPDATE_OPEN_KNOWLEDGE_BASE_ITEMS";
export const UPDATE_KNOWLEDGE_ITEM_ERRORS = "UPDATE_KNOWLEDGE_ITEM_ERRORS";
export const UPDATE_KNOWLEDGE_BASE_ACCORDION_ERROR = "UPDATE_KNOWLEDGE_BASE_ACCORDION_ERROR";

export const setKnowledgeBase = (knowledgeBase) => {
  return {
    type: SET_KNOWLEDGE_BASE,
    payload: knowledgeBase,
  };
};

export const updateKnowledgeBase = (knowledgeBase) => {
  return {
    type: UPDATE_KNOWLEDGE_BASE,
    payload: knowledgeBase,
  };
};

export const updateKnowledgeBaseItems = (items) => {
  return {
    type: UPDATE_KNOWLEDGE_BASE_ITEMS,
    payload: [...items],
  };
};

export const updateOpenKnowledgeBaseItems = (items) => {
  return {
    type: UPDATE_OPEN_KNOWLEDGE_BASE_ITEMS,
    payload: items,
  };
};

export const updateKnowledgeItemErrors = (errors) => {
  return {
    type: UPDATE_KNOWLEDGE_ITEM_ERRORS,
    payload: errors,
  };
};

export const updateKnowledgeBaseAccordionError = (error) => {
  return {
    type: UPDATE_KNOWLEDGE_BASE_ACCORDION_ERROR,
    payload: error,
  };
};
